"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var idb_1 = require("idb");
var broadcast_channel_1 = require("broadcast-channel");
var CommonDB = /** @class */ (function () {
    function CommonDB(dbName, version, onUpgrade, onDowngrade, onBlocked, onBlocking) {
        var _this = this;
        this.blocking = false;
        this.blocked = false;
        this.isSupported = function () { return __awaiter(_this, void 0, void 0, function () {
            var isAvailable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.supported === undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, CommonDB.isDBAvailable()];
                    case 1:
                        isAvailable = _a.sent();
                        this.supported = isAvailable;
                        if (!isAvailable) {
                            console.warn("Couldn't get an access to IndexedDB.");
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.supported];
                }
            });
        }); };
        this.notify = function (store, keys) {
            // sends the message containing store, keys which were updated to other tabs/windows
            var message = { store: store, keys: keys };
            _this.broadcastChannel.postMessage(message);
        };
        this.onChange = function (handler) {
            // listens to the channel. On receiving a message triggers the handler func
            _this.broadcastChannel.onmessage = handler;
        };
        this.closeAfterTimeout = function (timeout) {
            if (timeout === void 0) { timeout = 1000; }
            setTimeout(function () {
                var _a;
                (_a = _this.db) === null || _a === void 0 ? void 0 : _a.close();
            }, timeout);
        };
        this.getDB = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, error_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.db) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        // if global var db is not already set then open new connection
                        _a = this;
                        return [4 /*yield*/, idb_1.openDB(this.dbName, this.version, {
                                upgrade: function (db, oldVersion, newVersion, transaction) {
                                    // Called if this version of the database has never been opened before. Use it to specify the schema for the database.
                                    _this.onUpgrade(db, oldVersion, newVersion, transaction);
                                },
                                blocked: function () {
                                    _this.blocked = true;
                                    // Called if there are older versions of the database open on the origin, so this version cannot open.
                                    if (_this.onBlocked) {
                                        _this.onBlocked();
                                    }
                                    // wait 1 sec before closing the db to let app enough time to finish all requests
                                    _this.closeAfterTimeout();
                                },
                                blocking: function () {
                                    // Called if this connection is blocking a future version of the database from opening.
                                    _this.blocking = true;
                                    if (_this.onBlocking) {
                                        _this.onBlocking();
                                    }
                                    // wait 1 sec before closing the db to let app enough time to finish all requests
                                    _this.closeAfterTimeout();
                                },
                                terminated: function () {
                                    // browser killed idb, user cleared history
                                    console.warn('Unexpected IDB close');
                                },
                            })];
                    case 2:
                        // if global var db is not already set then open new connection
                        _a.db = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        if (error_1 && error_1.name === 'VersionError') {
                            indexedDB.deleteDatabase(this.dbName);
                            console.warn('IndexedDB was deleted because your version is higher than it should be (downgrade)');
                            this.onDowngrade();
                            throw error_1;
                        }
                        else {
                            throw error_1;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, this.db];
                }
            });
        }); };
        this.addItem = function (store, item, key, upsert) { return __awaiter(_this, void 0, void 0, function () {
            var db, _a, storeName, p;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = idb_1.unwrap;
                        return [4 /*yield*/, this.getDB()];
                    case 1:
                        db = _a.apply(void 0, [_b.sent()]);
                        storeName = store;
                        p = new Promise(function (resolve, reject) {
                            var _a, _b;
                            var tx = db.transaction(storeName, 'readwrite');
                            var params = key ? [item, key] : [item, undefined];
                            var req = upsert
                                ? (_a = tx.objectStore(storeName)).put.apply(_a, params) : (_b = tx.objectStore(storeName)).add.apply(_b, params);
                            req.onerror = function (_event) {
                                reject(req.error);
                            };
                            req.onsuccess = function (_event) {
                                _this.notify(store, [req.result]);
                                resolve(req.result);
                            };
                        });
                        return [2 /*return*/, p];
                }
            });
        }); };
        this.addItems = function (store, items, upsert) { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, keys, promises;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDB()];
                    case 1:
                        db = _a.sent();
                        // jest won't resolve tx.done when 'items' is empty array
                        if (items.length === 0)
                            return [2 /*return*/, Promise.resolve()];
                        tx = db.transaction(store, 'readwrite');
                        keys = [];
                        promises = Promise.all(items
                            .map(function (item) {
                            if (upsert) {
                                return tx.store.put(item).then(function (result) {
                                    keys.push(result);
                                });
                            }
                            return tx.store.add(item).then(function (result) {
                                keys.push(result);
                            });
                        })
                            .concat(tx.done)).then(function (_) {
                            _this.notify(store, keys);
                        });
                        return [2 /*return*/, promises];
                }
            });
        }); };
        this.getItemByPK = function (store, primaryKey) { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, item;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDB()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction(store);
                        return [4 /*yield*/, tx.store.get(primaryKey)];
                    case 2:
                        item = _a.sent();
                        return [2 /*return*/, item];
                }
            });
        }); };
        this.getItemByIndex = function (store, indexName, key) { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, index, item;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDB()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction(store);
                        index = tx.store.index(indexName);
                        return [4 /*yield*/, index.get(IDBKeyRange.only(key))];
                    case 2:
                        item = _a.sent();
                        return [2 /*return*/, item];
                }
            });
        }); };
        this.updateItemByIndex = function (store, indexName, key, updateObject) { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, index, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDB()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction(store, 'readwrite');
                        index = tx.store.index(indexName);
                        return [4 /*yield*/, index.get(key)];
                    case 2:
                        result = _a.sent();
                        if (result) {
                            Object.assign(result, updateObject);
                            this.notify(store, [result]);
                            return [2 /*return*/, tx.store.put(result)];
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.removeItemByPK = function (store, key) { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDB()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction(store, 'readwrite');
                        return [4 /*yield*/, tx.store.delete(key)];
                    case 2:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        }); };
        this.removeItemByIndex = function (store, indexName, key) { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, txIdIndex, cursor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDB()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction(store, 'readwrite');
                        txIdIndex = tx.store.index(indexName);
                        return [4 /*yield*/, txIdIndex.openCursor(IDBKeyRange.only(key))];
                    case 2:
                        cursor = _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!cursor) return [3 /*break*/, 5];
                        cursor.delete();
                        this.notify(store, cursor.value ? [cursor.value] : []);
                        return [4 /*yield*/, cursor.continue()];
                    case 4:
                        // eslint-disable-next-line no-await-in-loop
                        cursor = _a.sent();
                        return [3 /*break*/, 3];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.getItemsExtended = function (store, indexName, filters) { return __awaiter(_this, void 0, void 0, function () {
            var db, tx, index, cursor, items, counter, keyRange, cursor, items;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDB()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction(store);
                        if (!indexName) return [3 /*break*/, 14];
                        index = tx.store.index(indexName);
                        if (!(filters && filters.key !== undefined)) return [3 /*break*/, 8];
                        if (!(filters.offset !== undefined || filters.count !== undefined)) return [3 /*break*/, 7];
                        return [4 /*yield*/, index.openCursor(IDBKeyRange.bound([filters.key], [filters.key, '']))];
                    case 2:
                        cursor = _a.sent();
                        items = [];
                        counter = 0;
                        if (!cursor) return [3 /*break*/, 6];
                        if (!filters.offset) return [3 /*break*/, 4];
                        return [4 /*yield*/, cursor.advance(filters.offset)];
                    case 3:
                        cursor = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!(cursor && (!filters.count || counter < filters.count))) return [3 /*break*/, 6];
                        // iterate unless cursor returns null or we have enough items (count param)
                        items.push(cursor.value);
                        return [4 /*yield*/, cursor.continue()];
                    case 5:
                        // eslint-disable-next-line no-await-in-loop
                        cursor = _a.sent();
                        counter++;
                        return [3 /*break*/, 4];
                    case 6: return [2 /*return*/, items];
                    case 7:
                        keyRange = IDBKeyRange.bound([filters.key], [filters.key, '']);
                        return [2 /*return*/, index.getAll(keyRange)];
                    case 8:
                        if (!(filters && filters.reverse)) return [3 /*break*/, 13];
                        return [4 /*yield*/, index.openCursor(undefined, 'prev')];
                    case 9:
                        cursor = _a.sent();
                        items = [];
                        _a.label = 10;
                    case 10:
                        if (!cursor) return [3 /*break*/, 12];
                        items.push(cursor.value);
                        return [4 /*yield*/, cursor.continue()];
                    case 11:
                        // eslint-disable-next-line no-await-in-loop
                        cursor = _a.sent();
                        return [3 /*break*/, 10];
                    case 12: return [2 /*return*/, items];
                    case 13: return [2 /*return*/, index.getAll()];
                    case 14: 
                    // no accountId, return all txs
                    return [2 /*return*/, tx.store.getAll()];
                }
            });
        }); };
        this.getItemsWithKeys = function (store) { return __awaiter(_this, void 0, void 0, function () {
            var db, cursor, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDB()];
                    case 1:
                        db = _a.sent();
                        return [4 /*yield*/, db.transaction(store).store.openCursor()];
                    case 2:
                        cursor = _a.sent();
                        resp = [];
                        _a.label = 3;
                    case 3:
                        if (!cursor) return [3 /*break*/, 5];
                        resp.push({
                            key: cursor.key,
                            value: cursor.value,
                        });
                        return [4 /*yield*/, cursor.continue()];
                    case 4:
                        // eslint-disable-next-line no-await-in-loop
                        cursor = _a.sent();
                        return [3 /*break*/, 3];
                    case 5: return [2 /*return*/, resp];
                }
            });
        }); };
        this.clearStores = function (storeNames) { return __awaiter(_this, void 0, void 0, function () {
            var db, extractStoreNames, list, promises;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDB()];
                    case 1:
                        db = _a.sent();
                        extractStoreNames = function () {
                            var names = [];
                            var list = db.objectStoreNames;
                            var length = list.length;
                            for (var i = 0; i < length; i++) {
                                var storeName = list.item(i);
                                if (storeName) {
                                    names.push(storeName);
                                }
                            }
                            return names;
                        };
                        list = storeNames !== null && storeNames !== void 0 ? storeNames : extractStoreNames();
                        promises = list.map(function (storeName) {
                            var transaction = db.transaction(storeName, 'readwrite');
                            var objectStore = transaction.objectStore(storeName);
                            return objectStore.clear();
                        });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.removeDatabase = function () {
            if (_this.db) {
                _this.db.close();
            }
            return idb_1.deleteDB(_this.dbName);
        };
        if (CommonDB.instance) {
            return CommonDB.instance;
        }
        this.dbName = dbName;
        this.version = version;
        this.supported = undefined;
        this.onUpgrade = onUpgrade.bind(this);
        this.onDowngrade = onDowngrade.bind(this);
        this.onBlocked = onBlocked;
        this.onBlocking = onBlocking;
        this.db = null;
        this.blocking = false;
        this.blocked = false;
        this.isSupported();
        // create global instance of broadcast channel
        this.broadcastChannel = new broadcast_channel_1.BroadcastChannel('storageChangeEvent');
        CommonDB.instance = this;
    }
    CommonDB.isDBAvailable = function () {
        // Firefox doesn't support indexedDB while in incognito mode, but still returns valid window.indexedDB object.
        // https://bugzilla.mozilla.org/show_bug.cgi?id=781982
        // so we need to try accessing the IDB. try/catch around idb.open() does not catch the error (bug in idb?), that's why we use callbacks.
        // this solution calls callback function from within onerror/onsuccess event handlers.
        // For other browsers checking the window.indexedDB should be enough.
        var isFirefox = navigator && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        return new Promise(function (resolve, _reject) {
            if (isFirefox) {
                var r = indexedDB.open('test');
                r.onerror = function () { return resolve(false); };
                r.onsuccess = function () { return resolve(true); };
            }
            else {
                // @ts-ignore
                var idbAvailable = !!indexedDB || !!window.indexedDB || !!global.indexedDB;
                if (idbAvailable) {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            }
        });
    };
    CommonDB.removeStores = function (db) {
        var list = db.objectStoreNames;
        var length = list.length;
        for (var i = 0; i < length; i++) {
            var storeName = list.item(i);
            if (storeName) {
                db.deleteObjectStore(storeName);
            }
        }
    };
    return CommonDB;
}());
exports.default = CommonDB;
